import { OnInit, } from '@angular/core';
import { ABTest } from '@freelancer/abtest';
import { Auth } from '@freelancer/auth';
import { Datastore, } from '@freelancer/datastore';
import { IconSize } from '@freelancer/ui/icon';
import { toNumber } from '@freelancer/utils';
import * as Rx from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
var AwardModalComponent = /** @class */ (function () {
    function AwardModalComponent(abtest, auth, datastore, uiConfig) {
        this.abtest = abtest;
        this.auth = auth;
        this.datastore = datastore;
        this.uiConfig = uiConfig;
        this.IconSize = IconSize;
        this.showUpgrades = false;
    }
    AwardModalComponent.prototype.ngOnInit = function () {
        this.bidDoc = this.datastore.document('bids', this.bidId);
        this.bid$ = this.bidDoc.valueChanges();
        this.projectDoc = this.datastore.document('projectViewProjects', this.projectId);
        this.project$ = this.projectDoc.valueChanges();
        var escrowRequired$ = this.datastore
            .objects('users', Rx.combineLatest([
            this.auth.getUserId(),
            this.bid$.pipe(map(function (bid) { return bid.bidderId; })),
        ]).pipe(map(function (_a) {
            var authUid = _a[0], bidderId = _a[1];
            return [toNumber(authUid), bidderId];
        })))
            .pipe(map(function (users) { return users.some(function (u) { return u.escrowComInteractionRequired; }); }));
        if (this.showUpgrades) {
            this.cartVariant$ = Rx.of(true);
        }
        else if (this.abtest.isWhitelistUser()) {
            this.cartVariant$ = Rx.of(true);
        }
        else if (this.uiConfig.theme === 'arrow') {
            this.cartVariant$ = Rx.of(false);
        }
        else {
            this.cartVariant$ = Rx.combineLatest([
                this.project$,
                escrowRequired$,
            ]).pipe(switchMap(function (_a) {
                var projects = _a[0], escrowRequired = _a[1];
                // projects with local jobs not in the test
                if (projects.local && !escrowRequired) {
                    return Rx.of(false);
                }
                return Rx.of(true);
            }));
        }
        this.showNormalAwardModal$ = escrowRequired$.pipe(map(function (escrowRequired) { return !escrowRequired; }));
    };
    return AwardModalComponent;
}());
export { AwardModalComponent };
